import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = {
  key: 4,
  class: "text-right"
}
const _hoisted_6 = { key: 5 }
const _hoisted_7 = {
  key: 6,
  class: "text-right"
}
const _hoisted_8 = { key: 7 }
const _hoisted_9 = { style: {"font-weight":"bold"} }
const _hoisted_10 = {
  style: {"text-align":"right"},
  class: "text-right"
}
const _hoisted_11 = {
  style: {"text-align":"right"},
  class: "text-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_oss_data_table, {
            headers: _ctx.documentsHeaders,
            items: _ctx.documentAlsCreate,
            "fixed-header": true,
            "virtual-scroll": true,
            striped: true,
            dense: true,
            height: "42vh",
            loading: _ctx.loading,
            "items-per-page": _ctx.itemPerPage,
            "items-per-page-options": _ctx.itemPerPages,
            "hide-default-footer": _ctx.documentAlsCreate.length <= 50,
            "fixed-footer": true,
            class: "table elevation-0"
          }, {
            item: _withCtx((props) => [
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(props.item.date)), 1),
                (
                                props.item.accountableAccount &&
                                props.item.accountableAccount.connect &&
                                props.item.accountableAccount.connect.uniqueName &&
                                props.item.accountableAccount.connect.uniqueName.name
                            )
                  ? (_openBlock(), _createElementBlock("td", _hoisted_1, _toDisplayString(props.item.accountableAccount.connect.uniqueName.name), 1))
                  : (
                                props.item.accountableAccount &&
                                props.item.accountableAccount.connect &&
                                props.item.accountableAccount.connect.name
                            )
                    ? (_openBlock(), _createElementBlock("td", _hoisted_2, _toDisplayString(props.item.accountableAccount.connect.name), 1))
                    : (
                                props.item.accountableAccount && props.item.accountableAccount.name
                            )
                      ? (_openBlock(), _createElementBlock("td", _hoisted_3, _toDisplayString(props.item.accountableAccount.name), 1))
                      : (_openBlock(), _createElementBlock("td", _hoisted_4)),
                _createElementVNode("td", null, _toDisplayString(props.item.wording), 1),
                (props.item.amountSigned && props.item.amountSigned > 0)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_5, _toDisplayString(_ctx.newCommonFormatCurrency(
                                    Math.abs(props.item.amountSigned),
                                    undefined,
                                )), 1))
                  : (_openBlock(), _createElementBlock("td", _hoisted_6)),
                (props.item.amountSigned && props.item.amountSigned < 0)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(_ctx.newCommonFormatCurrency(
                                    Math.abs(props.item.amountSigned),
                                    undefined,
                                )), 1))
                  : (_openBlock(), _createElementBlock("td", _hoisted_8))
              ])
            ]),
            "body.append": _withCtx(() => [
              _createElementVNode("tr", _hoisted_9, [
                _cache[0] || (_cache[0] = _createElementVNode("th", null, null, -1)),
                _cache[1] || (_cache[1] = _createElementVNode("th", null, null, -1)),
                _cache[2] || (_cache[2] = _createElementVNode("th", { class: "text-left" }, "Totaux", -1)),
                _createElementVNode("th", _hoisted_10, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.debits, undefined)), 1)
                ]),
                _createElementVNode("th", _hoisted_11, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.newCommonFormatCurrency(-_ctx.credits, undefined)), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["headers", "items", "loading", "items-per-page", "items-per-page-options", "hide-default-footer"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}